<template>
  <transition name="fade">
    <AlertConfirmation
      v-if="alert_confirmation"
      @confirmNo="handle_clicked_no"
      @confirmYes="handle_clicked_yes"
      :animation_class="animation_alert_confirmation_class"
      text="Are you sure want to Logout?"
      text_class="text-xl font-medium"
      title="Logout"
    />
  </transition>
  <main class="overflow-y-auto max-h-dvh p-8">
    <Loading v-if="isLoading"/>
    <slot></slot>
    <button v-if="!isLoginPage" @click="logout" class="logout absolute top-4 right-4 bg-white/30 isLoginPagended-md border-white/40 border p-2 grayscale">
      <!-- <img src="/images/icons/logout.webp" alt="logout" width="30" height="30"> -->
      <ArrowRightStartOnRectangleIcon class="h-5 w-5 text-black/50" />
    </button>
    <MainMenu v-if="!isLoginPage"/>
  </main>
</template>

<script>
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import MainMenu from '@/components/organisms/MainMenu.vue';
import Loading from '@/components/molecules/Loading.vue';
import VueJwtDecode from 'vue-jwt-decode';
import { mapState } from 'vuex';
import { ArrowRightStartOnRectangleIcon } from "@heroicons/vue/24/solid";

export default {
  name: "AuthWrapper",
  components: {
    AlertConfirmation,
    MainMenu,
    Loading,
    ArrowRightStartOnRectangleIcon
  },
  data() {
    return {
      alert_confirmation: false,
      animation_alert_confirmation_class: "",
    };
  },
  async created() {
    this.$store.dispatch('detail_user/fetchUser');
    const token = localStorage.getItem('auth_token');

    const decodedToken = VueJwtDecode.decode(token);
    this.$store.commit('detail_user/setUserLogin', decodedToken);
   },
  computed: {
    ...mapState({
      isLoading: state => state.loading.isLoading,
    }),

    isLoginPage() {
      return this.$route.meta.login_page;
    }
  },
  methods: {
    handle_clicked_no() {
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.alert_confirmation = false;
    },
    handle_clicked_yes() {
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      localStorage.removeItem('auth_token');
      this.$router.push('/');
    },
    logout() {
      this.alert_confirmation = true;
    }
  }
}
</script>

<style scope>
  body {
    /* min-height: 100dvh; */
    /* overflow-x: hidden; */
    /* overflow-y: auto; */
    background-image: url('@public/images/background.webp');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.25);
    z-index: 1;
  }

  /* Membuat Semua Element Lain di dalam <main> Tetap Terlihat Diatas Overlay Gelap  */
  main > * {
    position: relative;
    z-index: 2;
  }
</style>